import React from "react";
import StudentService from "../../../services/student/StudentService";
import TimeLineState, { TimeLineProps } from "./TimeLine.models";
import "./TimeLine.scss";
import StudentDailyReports from "../../../services/work-report/StudentDailyReports";
import NotifyContext from "../../../contexts/NotifyContext";
import { Modal } from "react-bootstrap";

export default class TimeLine extends React.PureComponent<
  TimeLineProps,
  TimeLineState
> {
  static contextType = NotifyContext;

  studentService: StudentService;
  studentDailyReports: StudentDailyReports;

  constructor(props: any) {
    super(props);
    this.studentService = new StudentService();
    this.studentDailyReports = new StudentDailyReports();
    this.state = { datas: [], showModal: false, reportText: "" };
  }

  componentDidMount() {
    let self = this;

    self.getData();
  }

  getData = () => {
    let self = this;

    self.studentService.studyTimeCurrentWeek().then(function (response) {
      self.setState({ datas: response });
    });
  };

  sendReport = () => {
    this.sendToTelegram();
    this.sendToSMS();
    this.closeModal();
  };

  showDailyReportModal = () => {
    let self = this;

    self.studentDailyReports.getDailyReportText().then(function (response) {
      self.setState({ reportText: response, showModal: true });
    });
  };

  closeModal = () => this.setState({ showModal: false, reportText: "" });

  sendToTelegram = () => {
    let self = this;
    this.studentDailyReports.sendToTelegram().then(function (response) {
      if (response !== undefined)
        self.context.showNotify({
          badge: "success",
          title: "",
          description: "با موفقیت برای شما ارسال شد",
        });
      else {
        self.context.showNotify({
          badge: "danger",
          title: "نا موفق",
          description: "خطا در ارسال",
        });
      }
    });
  };

  copyToClipboard = () => {
    navigator.clipboard.writeText(this.state.reportText);

    this.context.showNotify({
      badge: "success",
      title: "",
      description: "کپی شد",
    });

    this.closeModal();
  };

  sendToSMS = () => this.studentDailyReports.sendToSMS();

  render(): React.ReactNode {
    let datas = this.state.datas;
    const { showModal } = this.state;

    return (
      <>
        <div className="time-line-area tk-card padding-bottom-remove">
          <b className="mr-3" style={{ color: "#fb9905", display: "block" }}>
            {this.props.username}
          </b>
          <b className="mr-3" style={{ color: "#fb9905" }}>
            وضعیت گزارشکار(هفته جاری)
          </b>
          <div className="mr-3 mt-4">
            <ul id="progressbar-icon">
              {datas.map((data, key) => (
                <li
                  className={
                    data.value == null
                      ? ""
                      : data.value === true
                        ? "mdi mdi-check-bold text-success"
                        : "mdi mdi-close-thick text-danger"
                  }
                  key={key}
                ></li>
              ))}
            </ul>
            <ul id="progressbar">
              {datas.map((data, key) => (
                <li
                  className={data.value != null ? "active" : ""}
                  id="step"
                  key={key}
                >
                  <div className="rotate">{data.title}</div>
                </li>
              ))}
            </ul>
          </div>

          <button
            className="btn btn-send-to-telegram"
            onClick={this.showDailyReportModal}
          >
            مشاهده گزارش کار روز
          </button>
        </div>
        <Modal
          show={showModal}
          onHide={() => this.setState({ showModal: false })}
          animation={true}
        >
          <Modal.Header>
            <Modal.Title>گزارش کار روز</Modal.Title>
          </Modal.Header>
          <Modal.Body className="view-exam-result-details-modal">
            <div>
              <pre style={{ fontFamily: "Dana-Fanum", textAlign: "right" }}>
                {this.state.reportText}
              </pre>
            </div>
          </Modal.Body>
          <Modal.Footer dir="ltr">
            <button
              className="btn btn btn-success tk-float-left"
              onClick={this.copyToClipboard}
            >
              کپی کردن{" "}
            </button>
            <button
              className="btn btn btn-primary tk-float-left"
              onClick={this.sendReport}
            >
              ارسال پیامک
            </button>
            <button
              className="btn btn btn-outline-primary tk-float-left"
              onClick={() => this.setState({ showModal: false })}
            >
              بستن
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
